import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { FunctionComponent, ReactNode, useRef } from 'react'
import { SliderContainer, StyledCarousel } from './styled'

interface ElasticSliderProps {
  settings?: any
  floatArrows?: boolean
  children: ReactNode
  noAutoPlay?: boolean
  displayArrows?: boolean
  displayItems?: number
}

export const ElasticSlider: FunctionComponent<ElasticSliderProps> = ({
  settings,
  floatArrows,
  children,
  noAutoPlay,
  displayArrows,
  displayItems
}) => {
  const container = useRef(null)
  const { isDevice } = useScreenSizes()

  return (
    <SliderContainer ref={container} id="slider-container" style={{padding:"0em .5em"}}>
      <StyledCarousel
        showArrows={isDevice ? false : displayArrows}
        enableAutoPlay={!noAutoPlay}
        itemsToScroll={isDevice ? 1 : 1}
        isRTL={false}
        itemsToShow={isDevice ? 1 : displayItems}
        pagination={isDevice ? true : false}
      >
        {children}
      </StyledCarousel>
    </SliderContainer>
  )
}
